export default __webpack_public_path__ + "static/media/entelai-doc.8b569571.svg";